import React from 'react';
interface AvatarProps {
  src?: string;
  initials: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}
export function Avatar({
  src,
  initials,
  size = 'md',
  className = ''
}: AvatarProps) {
  const sizeClasses = {
    sm: 'h-8 w-8 text-xs',
    md: 'h-10 w-10 text-sm',
    lg: 'h-12 w-12 text-base'
  };
  return <div className={`relative inline-flex items-center justify-center overflow-hidden rounded-full bg-slate-100 ${sizeClasses[size]} ${className}`} data-id="element-261">
      {src ? <img className="h-full w-full object-cover" src={src} alt={initials} data-id="element-262" /> : <span className="font-medium text-slate-600" data-id="element-263">{initials}</span>}
    </div>;
}